import { RARITY_VALUES } from '../constants';
import type { StatsSummary } from '../types/serverData';
import type { ChartData } from '../types/components';

/** Reshaped stats-summary payload consumed by the dashboard (see useStatsSummary's `select`). */
export interface DashboardStats {
  lastSnapshot: StatsSummary['lastSnapshot'];
  chartData: ChartData[];
}

/**
 * Flattens the raw snapshot series into the row shape Recharts expects. Pure and memoized via
 * react-query's `select`, so the dashboard receives ready-to-render chart rows.
 */
export const toDashboardChartData = (
  snapshots: StatsSummary['snapshots'] | undefined,
): ChartData[] =>
  (snapshots ?? []).map((item) => ({
    updated: item.updated,
    date: new Date(item.updated).toLocaleDateString(),
    players: item.data?.players || 0,
    cards: item.data?.cards || 0,
    players24h: item.data?.players24h || 0,
    cards24h: item.data?.cards24h || 0,
    [RARITY_VALUES.LIMITED]: item.data?.limited24h || 0,
    [RARITY_VALUES.RARE]: item.data?.rare24h || 0,
    [RARITY_VALUES.SUPER_RARE]: item.data?.super24h || 0,
    [RARITY_VALUES.UNIQUE]: item.data?.unique24h || 0,
  }));
